import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { DragulaService } from 'ng2-dragula';
import * as moment from 'moment';
import * as $$ from 'jquery';
import { runInThisContext } from 'vm';
import { environment } from '../../../../environments/environment';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-document-bon-ecoloc',
  templateUrl: './document-bon-ecoloc.component.html',
  styleUrls: ['./document-bon-ecoloc.component.css']
})
export class DocumentBonEcolocComponent implements OnInit {

  @Input() row;
  @Input() depuisPlanning;
  @Input() type;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  filename = '';
  i = 0;
  loadingIndicator: Boolean = false;
  deleteElm = [];
  data = []
  error = '';
  bon: any = {};
  clickFermer: Boolean = false;

  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.clickFermer = false;
    this.bon = this.row ? this.row.bon : {};
    this.type = this.type || (this.common.typeDoc !== '' ? this.common.typeDoc : this.type);

    this.getDocumentBon(this.bon.id).then(() => {
      this.getListDemmande(this.bon.id)
    });
  }

  async getDocumentBon(id) {
    this.loadingIndicator = true;
    this.data = []
    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': id
        },
      }
    };

    await this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.data = [...datas.data];
      }
    });
  }

  getListDemmande(clefBon) {
    const user = this.common.local.getObject('userDetail') || {};
    const url = `${environment.api_dmd}/${user['nom']}/demande/get/detaildemande/bon/${clefBon}`;
    return this.common.getURL(url).then(datas => {
      const listImageDemandeEcoGED = datas && datas[0] ? datas[0]['listImageDemandeEcoGED'] : []
      listImageDemandeEcoGED.forEach(elt => {
        elt.isdemande = true;
        elt.description = elt.description || '';
        this.getImage(elt);
      });
      this.data = [...this.data, ...listImageDemandeEcoGED];
      this.loadingIndicator = false;
    }).catch(error => console.log(error));
  }

  getImage(elt) {
    const user = this.common.local.getObject('userDetail') || {};
    elt.urlImage = `${environment.api_dmd}/${user['nom']}/demande/images/${elt.nomFichier}/${elt.isFromIncident}`;
  }

  addLigne() {
    this.data.push({});
    this.data = [...this.data];
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.data.filter(elt => elt !== row);
    this.data = temp;
  }

  close() {
    this.common.isHisto = false;
    this.hidefunction.emit();
  }

  valide() {
    this.common.isHisto = false;
    this.clickFermer = true;
    this.saveDocBon();
  }

  getNameFile(event, item) {
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);    
      this.deleteLigne(item);
      return;
    }                                    
    
    item.nomFichier = file.name;
    const fileReader = new FileReader();
    const ctrl = this;
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      item.contentBase64 = base64[1];
    };
    fileReader.readAsDataURL(file);
  }

  openDoc(row) {
    if (!row.isdemande) {
      this.openDocBon(row);
    } else {
      this.openFile(row.urlImage)
    }
  }

  openFile(url) {
    this.common.openFile(url);
  }


  openDocBon(row) {
    const param = {
      'servlet': 'DBImprimerDocuments',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_DOC_BON': {
          'typeParam': 'int',
          'valeur': row.id
        },
        'IS_DOC_LOCATION': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  onActivate(event) {
    if (event.type === 'dblclick') {
      if (event.row.id !== 0) {
        this.openDoc(event.row);
      }
    }
  }



  saveDocBon() {
    this.common.closeModal();
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.deleteDocBon(elt);
          prom.push(fct);
      });
    }
    const add = this.data.filter(elt => !elt.id);
    if (add.length) {
      add.forEach(elt => {
        if (elt.contentBase64) {
          elt.id = 0;
          const fct = this.addDocBon(elt);
          prom.push(fct);
        }
      });
    }

    if (prom.length) {
      Promise.all(prom).then(data => {
        if (data.length) {
          this.validefunction.emit(this.bon);
        }
        // this.common.closeModal();

      }).catch(error => {
        // this.common.closeModal();
        // this.error = error;
        // this.common.openModal(this.modalService, this.msg);
      });
    } else {
      this.validefunction.emit(this.bon);
      // this.common.closeModal();
    }
  }

  addDocBon(doc) {
    doc['clefObjetParent'] = this.bon ? this.bon['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  deleteDocBon(doc) {
    doc['clefObjetParent'] = this.bon ? this.bon['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  downloadAll() {
    const param = {
      'servlet': 'DBImprimerDocuments',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 11
        },
        'CLEF_PIECE': {
          'typeParam': 'int',
          'valeur': this.bon.id
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': this.common.activedModule || 0
        },
        'CLEF_TYPE_DOC_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': 0
        }      
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }
}
